import React, { useEffect, useState } from 'react';
import { FaShareNodes } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import ModalLayout from '../layouts/ModalLayout';
import InvitationLink from '../misc/InvitationLink';
import localContactService from '../../../services/community/localContactService';
import IconBadge from '../icons/IconBadge';

interface InvitationLinkModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  externalMemberId?: number;
}

export default function InvitationLinkModal({
  open,
  setOpen,
  externalMemberId,
}: InvitationLinkModalProps): JSX.Element {
  const [link, setLink] = useState<string>();
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    if (!link && externalMemberId)
      localContactService.generateFriendlyId(+externalMemberId).then(setLink);
  }, [open]);

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      closeButton
      className="z-50 mx-6 flex w-full max-w-[600px] flex-col rounded-[12px] bg-secondary-50 px-10 py-6 pb-4 pt-5">
      <div className="mb-6 flex w-full items-center">
        <IconBadge icon={FaShareNodes} />

        <div className="ml-4 flex w-full flex-col">
          <h1 className="text-2xl">{t('component.modal.localContactInvitationLink.title')}</h1>
          <p>{t('component.modal.localContactInvitationLink.subtitle')}</p>
        </div>
      </div>

      <InvitationLink link={link} />
    </ModalLayout>
  );
}
